import Typography from '@mui/material/Typography';

import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import Header from 'reservations/base/components/Header';
import {
  DRAWER_STATES,
  useBookingForm
} from 'reservations/form/providers/BookingFormProvider';

export const FormHeader = () => {
  const restaurantName = useRestaurantName();
  const { isModify, isWaitlist, drawerState } = useBookingForm();
  const isReplacingCard = drawerState === DRAWER_STATES.REPLACE_CARD;

  let ctaText;
  switch (true) {
    case isReplacingCard:
      ctaText = 'UPDATE YOUR SAVED CARD INFORMATION';
      break;
    case isModify:
      ctaText = 'COMPLETE YOUR UPDATED RESERVATION';
      break;
    case isWaitlist:
      ctaText = 'JOIN THE WAITLIST';
      break;
    default:
      ctaText = 'COMPLETE YOUR RESERVATION';
  }

  const headerText = isReplacingCard
    ? 'Are you sure you want to replace your saved card?'
    : restaurantName;

  return (
    <>
      <Typography
        sx={theme => ({
          fontWeight: 500,
          fontSize: '12px',
          color: theme.palette.soy.main,
          mb: '12px'
        })}
      >
        {ctaText}
      </Typography>
      <Header text={headerText} />
    </>
  );
};
